import { render } from "./DivisionLeadersSunC.vue?vue&type=template&id=475baa92&scoped=true"
import script from "./DivisionLeadersSunC.vue?vue&type=script&scoped=true&lang=js"
export * from "./DivisionLeadersSunC.vue?vue&type=script&scoped=true&lang=js"

import "./DivisionLeadersSunC.vue?vue&type=style&index=0&id=475baa92&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475baa92"]])

export default __exports__